import React, { useId } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { castMessages as messages } from '../messages/castMessages';
import { withBrandWord } from '../../music24/components/primitives/BrandWord';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the directed video; each part uses its own slice of it */
import styles from '../DirectedVideo.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ConsentBoxProps {
  checked: boolean;
  /** The cast has a person and the box is not ticked (design b4). */
  showError: boolean;
  disabled: boolean;
  onChange: (checked: boolean) => void;
}

/**
 * The consent tick of the cast (design b1, b4; fixed copy): "I have the right to use these photos,
 * and everyone in them agreed." A cast with a person cannot go on without it.
 */
const ConsentBoxComponent: React.FC<ConsentBoxProps> = ({ checked, showError, disabled, onChange }) => {
  const intl = useIntl();
  const tickId = useId();
  return (
    <label htmlFor={tickId} className={clsx(styles.consent, showError && styles.consentBad)}>
      <input
        id={tickId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className={clsx(styles.checkbox, checked && styles.checkboxOn)} aria-hidden>
        {checked && (
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M5 12l5 5 9-10" />
          </svg>
        )}
      </span>
      <span>
        <span className={styles.consentTitle}>{intl.formatMessage(messages.consent)}</span>
        <span className={styles.consentDetail}>{intl.formatMessage(messages.consentDetail)}</span>
        <span className={styles.consentDetail}>{withBrandWord(intl.formatMessage(messages.consentScope))}</span>
        {showError && (
          <span className={styles.consentError} role="alert">
            {intl.formatMessage(messages.consentError)}
          </span>
        )}
      </span>
    </label>
  );
};

export const ConsentBox = TypedMemo(ConsentBoxComponent);
